import api from '../api/axios';

const getAll = () => {
  return api.get('/api-clients');
};

const getById = (id) => {
  return api.get(`/api-clients/${id}`);
};

const create = (data) => {
  return api.post('/api-clients', data);
};

const update = (id, data) => {
  return api.patch(`/api-clients/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/api-clients/${id}`);
};

const regenerateKeys = (id) => {
  return api.post(`/api-clients/${id}/regenerate-keys`);
};

const toggleActive = (id) => {
  return api.post(`/api-clients/${id}/toggle-active`);
};

const getAvailableScopes = () => {
  return api.get('/api-clients/scopes/available');
};

const apiClientServices = {
  getAll,
  getById,
  create,
  update,
  remove,
  regenerateKeys,
  toggleActive,
  getAvailableScopes,
};

export default apiClientServices;
